import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";

export default function VentaCaballos() {
  return (
    <div id="venta-caballos" className="text-center">
        <Seo
  title="Venta de caballos | Propios y de particulares"
  description="Exposición y venta de caballos seleccionados. Asesoramiento y opción de usufructo para comprar con seguridad."
  path="/venta-caballos"
  image="https://madridcampogrande.es/og/default.jpg"
/>
<BreadcrumbLd
  items={[
    { name: "Inicio", path: "/" },
    { name: "Venta de caballos", path: "/venta-caballos" },
  ]}
/>
      <div className="container">
        {/* Título */}
        <div className="section-title" style={{ marginBottom: 16 }}>
          <h2>Venta de Caballos</h2>
        </div>

        {/* Imagen principal */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-md-8 col-md-offset-2">
            <img
              src="/img/intro-bg.jpg"
              alt="Venta de caballos"
              style={{
                width: "100%",
                borderRadius: 12,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                marginBottom: 20,
              }}
            />
          </div>
        </div>

        {/* Texto descriptivo */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-md-10 col-md-offset-1">
            <p style={{ fontSize: 16, marginBottom: 16 }}>
              Exposición y venta de caballos propios y particulares. Puede
              preguntar por otros caballos.
            </p>
            <p style={{ fontSize: 16, marginBottom: 16 }}>
              Con derecho de usufructo para mayor seguridad de no equivocarse a
              la hora de comprar su caballo.
            </p>
            <p style={{ fontSize: 16 }}>
              Somos especialistas en preparación y venta de caballos para niños.
              Así lo demuestran nuestros caballos de clases y puede ser
              corroborado por nuestros clientes.
            </p>
          </div>
        </div>

        {/* Botón a contacto */}
        <div className="row">
          <div className="col-md-12">
            <Link
              to="/contacto"
              className="btn btn-custom btn-lg"
              style={{
                padding: "12px 28px",
                borderRadius: "8px",
                background: "linear-gradient(135deg, #6a82fb, #56ccf2)",
                color: "#fff",
                fontWeight: 600,
                textDecoration: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                transition: "transform 0.2s ease",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              Solicitar información
            </Link>
          </div>
          
        </div>
        <div style={{ marginBottom: 40 }}>
            </div>
      </div>
    </div>
  );
}
